import { propertiesPersistedPromise } from 'fdsr-migration-layer';
import { fromHttpPromise } from 'pulse/adapters';

import type { RootPropertyGroupsParams } from './types';
import { PromiseClient } from 'hub-http/adapters/promiseClient';

export const defaultPropertyGroupsResolver = fromHttpPromise(
  'propertyGroupsResolver',
  (httpClient, { objectTypeId }: RootPropertyGroupsParams) =>
    propertiesPersistedPromise.makeFetchWithOpts({ refresh: true })({
      httpClient: httpClient as PromiseClient,
      frameworkTypeIdentifier: objectTypeId,
      query: {
        // Always pass `true`. We can derive the result of passing `false` from the result of passing `true`, but not the inverse.
        showHighlySensitiveProperties: true,
      },
    })
);
